export const initialOperatorsTable = {
    data: [],
    loading: false
}